"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@material-ui/core");
const react_1 = __importStar(require("react"));
const components_1 = require("@alcumus/components");
const ArrowDownward_1 = __importDefault(require("@material-ui/icons/ArrowDownward"));
const ArrowUpward_1 = __importDefault(require("@material-ui/icons/ArrowUpward"));
const useStyles = (0, core_1.makeStyles)({
    sortIcon: {
        position: 'absolute',
        paddingLeft: 4,
    },
});
const StyledTableRow = (0, core_1.withStyles)((theme) => ({
    root: {
        height: theme.spacing(3),
    },
}))(core_1.TableRow);
const StyledTableCell = (0, core_1.withStyles)(() => ({
    head: {
        padding: '0 16px',
        backgroundColor: components_1.StyleVariables.colors.grey1,
        color: components_1.StyleVariables.colors.grey4,
    },
}))(core_1.TableCell);
const SortableTableHeader = ({ headers, sortConfig = [], handleClick, }) => {
    const classes = useStyles();
    const sortBy = (0, react_1.useCallback)((propertyName) => {
        if (!sortConfig)
            return;
        let pendingChange = sortConfig;
        const index = pendingChange.findIndex((config) => config.propertyName === propertyName);
        if (index > -1) {
            const currentSortType = pendingChange[index].sortType;
            pendingChange.splice(index, 1);
            if (currentSortType === 'desc') {
                pendingChange = [{ propertyName: propertyName, sortType: 'asc' }];
            }
        }
        else {
            pendingChange = [{ propertyName: propertyName, sortType: 'desc' }];
        }
        if (handleClick)
            handleClick(pendingChange);
    }, [sortConfig]);
    const getSortIcon = (property) => {
        const config = sortConfig.find((sortConfig) => sortConfig.propertyName === property);
        return config ? (config.sortType === 'desc' ? (react_1.default.createElement(ArrowDownward_1.default, null)) : (react_1.default.createElement(ArrowUpward_1.default, null))) : null;
    };
    return (react_1.default.createElement(core_1.TableHead, null,
        react_1.default.createElement(StyledTableRow, null,
            headers &&
                headers.map((header) => (react_1.default.createElement(StyledTableCell, { key: header.id, onClick: () => sortBy(header.id), align: header.isNumeric ? 'right' : 'left' },
                    header.displayName,
                    react_1.default.createElement("span", { className: classes.sortIcon }, getSortIcon(header.id))))),
            react_1.default.createElement(StyledTableCell, { key: "kebab-menu" }))));
};
exports.default = SortableTableHeader;
